import React from 'react';
import { BLOCKS, MARKS, INLINES } from '@contentful/rich-text-types';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import * as Styled from './RichText.styled';
import RichTextPropTypes from '../../prop-types/rich-text';

const RichText = ({ richText, textSize }) => {
  /**
   * Specify how certain types should be rendered
   */
  const options = {
    renderMark: {
      [MARKS.BOLD]: (text) => <Styled.Bold>{text}</Styled.Bold>,
      [MARKS.ITALIC]: (text) => <Styled.Italic>{text}</Styled.Italic>
    },
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_node, children) => (
        <Styled.Text $textSize={textSize}>{children}</Styled.Text>
      ),
      [BLOCKS.HEADING_1]: (_node, children) => (
        <Styled.Heading1>{children}</Styled.Heading1>
      ),
      [BLOCKS.HEADING_2]: (_node, children) => (
        <Styled.Heading2>{children}</Styled.Heading2>
      ),
      [INLINES.HYPERLINK]: (node, children) => (
        <Styled.Link href={node.data.uri}>{children}</Styled.Link>
      ),
      [BLOCKS.UL_LIST]: (_node, children) => (
        <Styled.List>{children}</Styled.List>
      )
    }
  };

  return <>{documentToReactComponents(richText, options)}</>;
};

RichText.propTypes = RichTextPropTypes;

RichText.defaultProps = {
  textSize: 16
};

export default RichText;
